// Centralized Database Configuration
// This is the SINGLE SOURCE OF TRUTH for all Supabase credentials
// Update credentials here and they will be used everywhere in the application

export const DATABASE_CONFIG = {
  URL: 'https://hpmbxwbuoamijdyhpele.supabase.co',
  ANON_KEY: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhwbWJ4d2J1b2FtaWpkeWhwZWxlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg5OTYzOTUsImV4cCI6MjA2NDU3MjM5NX0.GRVeeotAIdddZxRdkhzhD_2OMEDT1KhALZxwD5jVIIQ'
};

// Export individual values for convenience
export const SUPABASE_URL = DATABASE_CONFIG.URL;
export const SUPABASE_KEY = DATABASE_CONFIG.ANON_KEY;

// Helper function to get headers for direct REST API calls.
// Sends the signed-in user's JWT as the Bearer token (so PostgREST sees
// auth.uid() correctly and RLS policies key off the real user) and keeps
// the anon key in the apikey header for the API gateway. Falls back to
// the anon key as Bearer when no session exists yet (auth/signup pages),
// which preserves pre-login behavior exactly. Mirrors the pattern already
// used by autoAssignToCounts.js, priceHistory.js and vendorResolution.js.
export const getSupabaseHeaders = async () => {
  let token = null;

  try {
    if (typeof window !== 'undefined' && window.supabase && window.supabase.auth && window.supabase.auth.getSession) {
      const { data } = await window.supabase.auth.getSession();
      token = data && data.session && data.session.access_token ? data.session.access_token : null;
    }
  } catch (_) {}

  if (!token && typeof localStorage !== 'undefined') {
    try {
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (!key || !key.startsWith('sb-') || !key.endsWith('-auth-token')) continue;
        try {
          const parsed = JSON.parse(localStorage.getItem(key));
          if (parsed && parsed.access_token) { token = parsed.access_token; break; }
        } catch (_) {}
      }
    } catch (_) {}
  }

  return {
    'apikey': SUPABASE_KEY,
    'Authorization': `Bearer ${token || SUPABASE_KEY}`,
    'Content-Type': 'application/json'
  };
};

